import CloseIcon from "@material-ui/icons/Close";
import Style from "./newCloseIcon.module.css";

export const NewCloseIconButton = (props) => {
  return (
    <CloseIcon className={Style.closeIconButton} onClick={props.onClick} />
  );
};
